import { createSlice } from '@reduxjs/toolkit'
import initialState from "./initialState";
import reducers from "./reducers";
import { liquidGetCart } from "./thunks";
import PubSub, { Message } from "Utils/pubSub";

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(liquidGetCart.fulfilled, (state, action) => {
        const cart = action?.payload
        if (cart) {
          PubSub.publish(Message.CartLoaded, {cart})
          state.id = cart?.id;
          state.items = cart?.cartItems || [];
          state.subtotal = cart?.subtotal;
        } else {
          state.empty = true
        }
        state.loading = false
      })
      .addCase(liquidGetCart.pending, (state, action) => {
        state.loading = true
      })
      .addCase(liquidGetCart.rejected, (state, action) => {
        state.loading = false
        state.empty = true
      })

  }
})

export const {
  setLoading,
  setCart,
  setEngraving,
  setBundle,
  updateItem,
  removeItem,
  setSelectedEngraving,
  clearRemovedItems,
  addRemovedItem,
} = cartSlice.actions

const reducer = cartSlice.reducer
export default reducer
